import { useEffect } from 'react';

import { LoadingIndicator } from '@bambi/component-library/src/components/LoadingIndicator/LoadingIndicator';
import { useNavigate } from 'react-router';

import { useFeature } from 'src/app/FeatureToggle';

export function TripRequestFormScreen() {
  const navigate = useNavigate();
  const { isLoading, isEnabled } = useFeature('trip request form');

  useEffect(() => {
    if (!isLoading && !isEnabled) {
      navigate('/settings');
    }
  }, [navigate, isLoading, isEnabled]);

  if (isLoading) {
    return (
      <div className="flex h-full w-full items-center justify-center p-8">
        <LoadingIndicator />
      </div>
    );
  }

  if (!isEnabled) {
    return null;
  }

  return <div>Trip Request Form</div>;
}
